import { rwaConditionsActions } from '../state/rwa-conditions'

export function createGetRWAConditionSaga() {
    return function* (action: ReturnType<typeof rwaConditionsActions.getRwaCondition>) {}
}
